import { IndustryFiltersData } from "@assets/mocks/filterData";
import { useNavigate } from "react-router";
import { selectFavFilters, toggleFavorite } from "@redux/slices/favourite";
import { Star } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { FilterItem } from "@/types/filters";
import useAuth from "@hooks/useAuth";

import { FilterAtom } from "@/App";
import {useRecoilState } from "recoil";
import Industry from "../../../../assets/icons/IndustriesIcons/Industry.png";

import IndustryCode from "../../../../assets/icons/IndustriesIcons/Industry codes.png";

import IndustryCodeXZ from "../../../../assets/icons/IndustriesIcons/Industry codes.png";

const Industries = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {user}=useAuth();

  const favFilters = useSelector(selectFavFilters);
  const handleToggleFav = (val: FilterItem, index: number) => {
    const existingIndex = favFilters.findIndex(
      (fav) => fav.index === index && fav.path === val.path
    );
    console.log(existingIndex);
    dispatch(
      toggleFavorite({
        title: val.title,
        description: val.description,
        path: val.path,
        index,
      })
    );
  };

  const iconsList = [
    {
      
      src: Industry
    },
    {
      
      src: IndustryCode
    },
    {
     
      src: IndustryCodeXZ
    },
    
  ];

  const isFav = (path: string): boolean => {
    const fav = favFilters.some((fav) => fav.path === path);
    return fav;
  };

  const [filter, setFilter] = useRecoilState(FilterAtom); 

  return (
    <div className="w-2/3">
      <div className="flex gap-3">
        {IndustryFiltersData.slice(0, 3)?.map((val, index) => {
          return (
            <div
            className={`bg-white flex justify-center items-center text-center px-4 flex-col h-52 rounded-lg w-1/3 cursor-pointer relative 
              ${filter.includes(val.title) ? 'border-4' : ''}`} // Add border conditionally
  style={{ borderColor: filter.includes(val.title) ? '#1CB5AF' : 'transparent' }}
              
  onClick={() => navigate(`/targetMarkets/${user?.role}/?filter=${val.path}`)}
            >
              <img src="/assets/images/image 5.svg" alt="" />
              {/* <Star
                className={`absolute top-5 right-5 cursor-pointer ${
                  isFav(val.path) ? "fill-current text-yellow-500" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation(); 
                  handleToggleFav(val, index);
                }}
              /> */}

<img
                src={iconsList[index].src}
                alt=""
                className="h-[75px]"
              />
              <h6 className="text-gray text-lg font-medium pt-2 pb-3">
                {val.title}
              </h6>
              <p className="text-[#71717A] text-sm">{val.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Industries;
